
<div class="k-row">
    <div style="
          display:inline;
          text-align:right;
          padding-bottom: 10px;
          padding-top: 10px;" class="ng-star-inserted">
        <button
                class="k-generic-btn ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
                *ngIf="show!='list'"
                (click)="showList()"
                style="height: 40px;"
                pButton
                type="button"
                label="{{labelButtonBack}}">
        </button>
    </div>
</div>



<app-suppliers-list
        *ngIf="show=='list'"
        (customButtonBrand)="showBrand($event)"
        (customButtonCertification)="showCertification($event)"
    >
</app-suppliers-list>



<app-supplier-brand
        *ngIf="show=='brand'"
        [supplier]="selectedSupplier"
>
</app-supplier-brand>



<app-supplier-certification
        *ngIf="show=='certification'"
        [supplier]="selectedSupplier"
>
</app-supplier-certification>





// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier.component.html